import "./DressCode.css";

export default function DressCode() {
  return (
    <section className="seccion dresscode">
      <div className="dresscode-card">
        <img 
          src="/prendas.gif" 
          alt="Icono vestimenta elegante sport"
          className="dresscode-icono"
        />
        <h2>Código de Vestimenta</h2>
        <p>
          La celebración será <strong className="resaltado">Elegante Sport</strong>.  
          Te invitamos a venir cómodo/a pero con un toque distinguido.
        </p>
      </div>
    </section>
  );
}
